import React, { useState } from 'react';
import { loadModules } from "esri-loader";

export function loadMap(container, basemap) {
  return loadModules(
    ["esri/Map",
      "esri/views/MapView",
      "esri/layers/FeatureLayer"
    ],
    // this stylesheet is only loaded once
    { css: "https://js.arcgis.com/4.10/esri/css/main.css" }
  ).then(([Map, MapView, FeatureLayer]) => {

    const map = new Map({
      basemap: "osm"
    });

    // Define a pop-up for weather beacons
    const popupWeather = {
      "title": "Weather Data",
      "content": "<b>Station:</b> {STATION_NAME}<br><b>Temp:</b> {TEMP}<br><b>Wind Speed:</b> {WIND_SPEED}<br><b>Weather:</b> {WEATHER}<br><b>Humidity:</b> {R_HUMIDITY}"
    }

    //weather feature layer (points)
    const weatherLayer = new FeatureLayer({
      url: "https://services9.arcgis.com/RHVPKKiFTONKtxq3/arcgis/rest/services/NOAA_METAR_current_wind_speed_direction_v1/FeatureServer",
      outFields: ["STATION_NAME","TEMP","R_HUMIDITY","WIND_DIRECT","WIND_SPEED", "WIND_GUST","WEATHER"],
      popupTemplate: popupWeather
    });

   
    // Define a pop-up for weather Forecast
    const popupForecast = {
      "title": "Weather Forecast",
      "content": "<b>Station:</b> {STATION_NAME}<br><b>Temp:</b> {TEMP}<br><b>Wind Speed:</b> {WIND_SPEED}<br><b>Weather:</b> {WEATHER}<br><b>Humidity:</b> {R_HUMIDITY}"
    }

    // Define a weather forecast layer
    const weatherForecast = new FeatureLayer({
      url: "https://services9.arcgis.com/RHVPKKiFTONKtxq3/arcgis/rest/services/NDFD_Precipitation_v1/FeatureServer",  
      outFields: ["STATION_NAME","TEMP","R_HUMIDITY","WIND_DIRECT","WIND_SPEED", "WIND_GUST","WEATHER"], 
      popupTemplate: popupForecast,
      opacity: 0.5  
    });


    // Define a pop-up for Storm Warnings
    const popupStormWarn = {
      "title": "Storm Warnning",
      "content": "<b>Type:</b> {INCIDENT_TYPE}<br><b>Date:</b> {INCIDENT_DATETIME}<br><b>Location:</b> {LOCATION}<br><b>Comments:</b> {COMMENTS}"
    }

    // define storm warnings layer
    const stormWarnings = new FeatureLayer({
      url: "https://services9.arcgis.com/RHVPKKiFTONKtxq3/arcgis/rest/services/NOAA_storm_reports_v1/FeatureServer/4",
      outFields: ["INCIDENT_TYPE" ,"INCIDENT_DATETIME", "LOCATION", "COMMENTS" ],
      popupTemplate: popupStormWarn,
    });

    const lineLayer = new FeatureLayer({
      // url: "https://services.arcgis.com/V6ZHFr6zdgNZuVG0/ArcGIS/rest/services/Electric_Line/FeatureServer/110",
      url: "https://services1.arcgis.com/Hp6G80Pky0om7QvQ/arcgis/rest/services/Transmission_Lines_gdb/FeatureServer/0",      
      popupTemplate: {
        title: "{NAME}",
        outFields: ["OWNER", "VOLTAGE", "SUB_1", "SUB_2"],
        lastEditInfoEnabled: false,
        actions: [
          {
            id: "find-station",
            image: "https://developers.arcgis.com/javascript/latest//sample-code/popup-custom-action/live/beer.png",
            title: "station Info"
          }
        ],
        content: [
          {
            type: "fields",
            fieldInfos: [
              {
                fieldName: "OWNER"
              },
              {
                fieldName: "VOLTAGE",                
              },
              {
                fieldName: "SUB_1",
              },
              {
                fieldName: "SUB_2"
              }
            ]
          }
        ]
      }
    });
    map.add(lineLayer);
    map.add(weatherLayer);
    map.add(weatherForecast);
    map.add(stormWarnings);


    const view = new MapView({
      container,
      map: map,
      center: [-105.009065, 39.618691], // Longitude, latitude
      zoom: 10,
    });

    return view;
  });
}
